<template>
  <div class="liveCardWrap">
    <div
      class="live_on_header"
      :style="{
        background: `url(${teacherInfo.image}) center center / 100% no-repeat`,
      }"
    >
      <div class="frosted-glass"></div>
      <div class="lottie">
        <lottie :options="defaultOptions" v-on:animCreated="handleAnimation" />
      </div>
      <div class="live_on_img">
        <img :src="teacherInfo.image" alt="avatar" />
        <div class="live_on">
          <i></i>
        </div>
      </div>
      <div class="live_on_text">
        <h2>{{ liveCardInfo.room_name }}</h2>
        <!--5.9万 ·-->
        <p>{{ liveCardInfo.duration }}</p>
      </div>
      <div class="join_btn" @click="open_live">
        点击进入
      </div>
    </div>
  </div>
</template>
<script>
import lottie from "vue-lottie";
import Anim from "@/assets/ks.json";
export default {
  name: "",
  data() {
    return {};
  },
  props: {
    liveCardInfo: {
      // 直播卡片信息
      type: Object,
      default: () => {
        return {};
      },
    },
    teacherInfo: {
        type: Object,
        default: ()=>{
            return {}
        }
    },
  },
  components: {
    lottie: lottie,
  },
  data() {
    return {
      defaultOptions: { animationData: Anim, loop: true, autoplay: true },
      defaultAnim: "",
      timer: null,
    };
  },
  created() {
  },
  methods: {
    handleAnimation: function (anim) {
      this.defaultAnim = anim;
    },
    open_live() {
      this.openNative('video_live_page', {
        id: this.liveCardInfo.room_id
      })
    },
    // 跳转APP页面
    openNative(type, query = {}) {
        let params = {
            kind: type, // 类型
        };

        params = {
          ...params,
          ...query
        }

        switch (type) {
            case "video_live_page": // 视频直播间
                break;
        }

        this.$srH5CallNativeMethodApp('call_Native', params)
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style scoped lang="scss">
@import "~@/assets/sass/global.scss";
.liveCardWrap {
  background: #fff;
  margin-top: rem2(12px);
  overflow: hidden;

  .live_on_header {
    display: flex;
    position: relative;
    margin: 0 rem2(18px);
    height: rem2(93.5px);
    box-shadow: 0 rem2(1px) rem2(5px) 0 rgba(217, 217, 217, 0.5);
    border-radius: rem2(10px);
    border: rem2(0.5px) solid #CCC;

    .live_on_img {
      flex-shrink: 0;
      z-index: 2;
      position: relative;
      margin: rem2(10.5px) rem2(14px) 0 rem2(14px);
      width: rem2(65.5px);
      height: rem2(65.5px);
      border-radius: 50%;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: rem2(3px) solid #fa4547;
      }
      .live_on {
        position: absolute;
        width: rem2(55px);
        height: rem2(17px);
        background: url(https://cdn.stock-ring.com/static/wap/img/live_on.png) no-repeat;
        background-size: contain;
        border-radius: rem2(16px);
        top: rem2(55px);
        left: rem2(8px);
        i {
          width: rem2(10px);
          height: rem2(8px);
          background: url(https://cdn.stock-ring.com/static/wap/img/live.gif) no-repeat;
          position: absolute;
          left: rem2(4.5px);
          top: rem2(3.5px);
          background-size: 100%;
        }
      }
    }
    .live_on_text {
      z-index: 2;
      position: relative;
      flex: 1;
      min-width: 0;
      h2 {
        margin: rem2(20px) 0 rem2(20.5px);
        font-size: rem2(15px);
        font-weight: 500;
        color: #fefffe;
        line-height: rem2(18px);
        max-width: 90%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      p {
        font-size: rem2(12px);
        font-weight: 400;
        color: #fefffe;
        line-height: rem2(16px);
        //热度先不做
      }
    }
    .frosted-glass {
      border-radius: rem2(40px);
      position: absolute;
      background: inherit;
      -moz-filter: blur(rem2(23px));
      -ms-filter: blur(rem2(23px));
      -o-filter: blur(rem2(23px));
      filter: blur(rem2(23px));
      filter: progid:DXImageTransform.Microsoft.Blur(PixelRadius=4, MakeShadow=false);
      width: 100%;
      height: 100%;
      backdrop-filter: blur(rem2(23px));
    }
    .join_btn {
      z-index: 2;
      width: rem2(70.5px);
      height: rem2(27.5px);
      background: #ff3030;
      border-radius: rem2(13.75px);
      margin-top: rem2(51px);
      font-size: rem2(12px);
      font-weight: 400;
      color: #fefffe;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: rem2(19.5px);
      bottom: rem2(15px);
    }
    &:before {
      position: absolute;
      top: 0;
      left: 0;
      content: "";
      background-color: #2b2b2b;
      opacity: 0.18;
      z-index: 0;
      width: 100%;
      height: 100%;
      border-radius: rem2(10px);
      z-index: 1;
    }
  }

  .lottie {
    width: 50%;
    height: 190%;
    transform: translate3d(0, 0, 0);
    text-align: center;
    opacity: 1;
    position: absolute;
    top: -45%;
    left: -10%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
</style>